var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatedbyFilterDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4238_1847)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4238_1847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.69714 7.32681L4.81302 7.33195C4.88985 7.33815 4.96608 7.35032 5.04107 7.36815L5.15326 7.39914L5.15474 7.3999L5.70016 7.57848L5.85958 7.62648C6.65845 7.85253 7.50798 7.83681 8.29957 7.57848L8.84501 7.3999L8.84652 7.39914L8.95868 7.36815C9.07152 7.34117 9.187 7.32719 9.30407 7.32681H9.51961C10.2461 7.32689 10.9426 7.61605 11.4563 8.12982C11.97 8.64352 12.2592 9.33996 12.2593 10.0665V10.8156C12.2588 11.1347 12.1449 11.4434 11.9382 11.6865C11.7315 11.9296 11.4449 12.0916 11.1301 12.1433H11.1293C8.39472 12.5902 5.60502 12.5902 2.87044 12.1433C2.21922 12.0372 1.74121 11.4748 1.74121 10.8148V10.0665C1.74128 9.34004 2.02991 8.64352 2.54349 8.12982C3.05727 7.61605 3.75428 7.32681 4.48088 7.32681H4.69714ZM6.99988 1.52344C8.29526 1.52344 9.34541 2.57357 9.34541 3.86899C9.34541 5.1644 8.29526 6.21454 6.99988 6.21454C5.70461 6.21438 4.65433 5.1643 4.65433 3.86899C4.65433 2.57368 5.70461 1.5236 6.99988 1.52344Z",
    strokeWidth: 1.1375,
    stroke: "#CCCCCC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4238_1847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4238_1847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatedbyFilterDark);
export default __webpack_public_path__ + "static/media/createdby-filter-dark.18b851d1152b30cb4f12ed8dd75c3c6a.svg";
export { ForwardRef as ReactComponent };